import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CentralistModeService {
  private readonly CENTRALIST_MODE_KEY = 'centralist_mode';
  private readonly FIRST_LOGIN_KEY = 'first_login_completed';
  
  private centralistModeSubject = new BehaviorSubject<boolean>(this.getCentralistMode());
  public centralistMode$ = this.centralistModeSubject.asObservable();

  constructor() {}

  private getCentralistMode(): boolean {
    return localStorage.getItem(this.CENTRALIST_MODE_KEY) === 'true';
  }

  setCentralistMode(enabled: boolean): void {
    localStorage.setItem(this.CENTRALIST_MODE_KEY, enabled.toString());
    this.centralistModeSubject.next(enabled);
  }

  isCentralistMode(): boolean {
    return this.centralistModeSubject.value;
  }

  shouldShowModeSelection(): boolean {
    // Always show mode selection on every login
    return true;
  }

  exitCentralistMode(): void {
    this.setCentralistMode(false);
  }
}